module.exports = __webpack_public_path__ + "static/media/promotion_image_ro.41d8909a.jpg";